import { getLeadActions } from './action';


const initialState = {

  leadData: []
};

const viewLeadReducer = (state = initialState, action) => {
  switch (action.type) {
    case getLeadActions.GET_LEAD_SUCCESS:
      return {
        ...state,
        leadData: action.payload,
        error: ''

      };

    case getLeadActions.GET_LEAD_ERROR:
      return {
        ...state,
        leadData: [],
        error: action.payload,
      };







    default:
      return state;
  }
};


export default viewLeadReducer;